module.exports = __webpack_public_path__ + "data/star.json";


//////////////////
// WEBPACK FOOTER
// ./app/common/thing-star/star.json
// module id = euRd
// module chunks = 1